import { render, staticRenderFns } from "./FormProductFeed.vue?vue&type=template&id=bfd423b8&scoped=true&"
import script from "./FormProductFeed.vue?vue&type=script&lang=js&"
export * from "./FormProductFeed.vue?vue&type=script&lang=js&"
import style0 from "./FormProductFeed.vue?vue&type=style&index=0&id=bfd423b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd423b8",
  null
  
)

export default component.exports